export const buildSummedReimbursements = function (tab, rrTab) {
    return {
        'first-row': {
            valueCells: [
                {
                    editable: false,
                    nameClasses: 'font-gotham-bold font-size-9',
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs[rrTab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                        return {internalValue: value, displayValue: displayValue};
                    },
                },
                {empty: true},
                {
                    editable: false,
                    nameClasses: 'font-gotham-bold font-size-9',
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs[tab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[3].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue};
                    },
                },
                {   nameClasses: 'font-gotham-bold font-size-9',
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs[tab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[4].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue};
                    },
                },
                {
                    editable: false,
                    nameClasses: 'font-gotham-bold font-size-9',
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs[tab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[5].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue};
                    },
                },
                {   nameClasses: 'font-gotham-bold font-size-9',
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs[tab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[6].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue};
                    },
                },
                {
                    editable: false,
                    nameClasses: 'font-gotham-bold font-size-9',
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs[tab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[7].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue};
                    },
                },
                {   nameClasses: 'font-gotham-bold font-size-9',
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs[tab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[8].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue};
                    },
                },
                {
                    editable: false,
                    nameClasses: 'font-gotham-bold font-size-9',
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs[tab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[9].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue};
                    },
                },
                {   nameClasses: 'font-gotham-bold font-size-9',
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs[tab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[10].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue};
                    },
                },
                {
                    editable: false,
                    nameClasses: 'font-gotham-bold font-size-9',
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs[tab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[13].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue};
                    },
                },
                {   nameClasses: 'font-gotham-bold font-size-9',
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs[tab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[14].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue};
                    },
                },
            ]
        },
        'second-row': {
            valueCells: [
                {
                    editable: false,
                    nameClasses: 'font-gotham-bold font-size-9',
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs[rrTab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                        return {internalValue: value, displayValue: displayValue};
                    },
                },
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
            ]
        },
        'third-row': {
            valueCells: [
                {
                    editable: false,
                    nameClasses: 'font-gotham-bold font-size-9',
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs[rrTab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                        return {internalValue: value, displayValue: displayValue};
                    },
                },
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
            ]
        }
    }
};

export const summedReimbursements = {
    hasNamesColumn: false,
    headerRow: [],
    rows: {}
};